import React from "react"
import { Col, Row } from "react-bootstrap" // Oder dein entsprechendes Grid-System
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLightbulb, faPeopleCarry, faSmileWink, faUserFriends } from "@fortawesome/free-solid-svg-icons"
import { Link } from "gatsby"

const CompanyStats = () => {
  const startYear = 2003
  const logisticYears = new Date().getFullYear() - startYear

  const stats = [
    {
      icon: faPeopleCarry,
      title: `${logisticYears} Jahre`,
      subtitle: "Logistik",
      alt: "Logistik seit 2003"
    },
    {
      icon: faUserFriends,
      title: "15+",
      subtitle: "Mitarbeiter",
      alt: "Mitarbeiter"
    },
    {
      icon: faLightbulb,
      title: "100%",
      subtitle: "Innovativ",
      alt: "Innovativ"
    },
    {
      icon: faSmileWink,
      title: "100%",
      subtitle: "Kundenorientiert",
      alt: "Kundenorientiert"
    }
  ]

  return (
    <section className="company-stats-section" style={{ maxWidth: "600px", alignSelf: "center" }}>
      {/* Statistiken Grid */}
      <Row className="mb-4">
        {stats.map((stat, index) => (
          <Col lg={6} md={6} key={index}>
            <div className="d-flex flex-row border m-2 p-2" style={{ gap: "10px" }}>
              <div className="m-2">
                <FontAwesomeIcon icon={stat.icon} alt={stat.alt} size="3x" />
              </div>
              <div className="m-1">
                <h3 className="mb-0">{stat.title}</h3>
                <p className="mb-0">{stat.subtitle}</p>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      {/* Action Buttons */}
      <div className="d-flex flex-md-row flex-column">
        <Link to="/firmenhistorie/" className="btn btn-secondary mx-2 my-2 btn-lg">
          Zur Firmenhistorie
        </Link>

        <Link to="/kundenprojekte/" className="btn btn-primary mx-2 my-2 btn-lg">
          Zu den Projekten
        </Link>
      </div>
    </section>
  )
}

export default CompanyStats
